type EmbedServiceConfig = {
  embedUrl: string;
  id?: (ids: string[]) => string;
};

export const embedServices: Record<string, EmbedServiceConfig> = {
  vk: {
    embedUrl: 'https://vk.com/video_ext.php?<%= remote_id %>&hd=2',
    id: (ids) => `oid=${ids[0]}&id=${ids[1]}`,
  },
  'vk-video': {
    embedUrl: 'https://vk.com/video_ext.php?<%= remote_id %>&hd=2',
    id: (ids) => `oid=${ids[0]}&id=${ids[1]}`,
  },
  vimeo: {
    embedUrl: 'https://player.vimeo.com/video/<%= remote_id %>?title=0&byline=0',
  },
  youtube: {
    embedUrl: 'https://www.youtube.com/embed/<%= remote_id %>',
    id: ([id, params]) => {
      if (!params && id) return id;

      const paramsMap = {
        start: 'start',
        end: 'end',
        t: 'start',
        time_continue: 'start',
        list: 'list',
      };

      const newParams = params?.slice(1)
        .split('&')
        .map(param => {
          const [name, value] = param.split('=');
          if (!id && name === 'v') {
            id = value;
            return null;
          }
          if (!paramsMap[name]) return null;
          if (['LL', 'RDMM', 'FL'].some(prefix => value?.startsWith(prefix))) return null;
          return `${paramsMap[name]}=${value}`;
        })
        .filter(Boolean);

      return id + (newParams.length ? `?${newParams.join('&')}` : '');
    }
  },
  coub: {
    embedUrl: 'https://coub.com/embed/<%= remote_id %>',
  },
  vine: {
    embedUrl: 'https://vine.co/v/<%= remote_id %>/embed/simple/',
  },
  imgur: {
    embedUrl: 'http://imgur.com/<%= remote_id %>/embed',
  },
  gfycat: {
    embedUrl: 'https://gfycat.com/ifr/<%= remote_id %>',
  },
  'twitch-channel': {
    embedUrl: 'https://player.twitch.tv/?channel=<%= remote_id %>',
  },
  'twitch-video': {
    embedUrl: 'https://player.twitch.tv/?video=v<%= remote_id %>',
  },
  'yandex-music-album': {
    embedUrl: 'https://music.yandex.ru/iframe/#album/<%= remote_id %>/',
  },
  'yandex-music-track': {
    embedUrl: 'https://music.yandex.ru/iframe/#track/<%= remote_id %>/',
    id: (ids) => ids.join('/'),
  },
  'yandex-music-playlist': {
    embedUrl: 'https://music.yandex.ru/iframe/#playlist/<%= remote_id %>/show/cover/description/',
    id: (ids) => ids.join('/'),
  },
  codepen: {
    embedUrl: 'https://codepen.io/<%= remote_id %>?height=300&theme-id=0&default-tab=css,result&embed-version=2',
    id: (ids) => ids.join('/embed/'),
  },
  instagram: {
    embedUrl: 'https://www.instagram.com/p/<%= remote_id %>/embed',
    id: (groups) => groups?.[0]?.split("/")[0],
  },
  twitter: {
    embedUrl: 'https://platform.twitter.com/embed/Tweet.html?id=<%= remote_id %>',
    id: ids => ids[1],
  },
  pinterest: {
    embedUrl: 'https://assets.pinterest.com/ext/embed.html?id=<%= remote_id %>',
    id: (ids) => ids[1],
  },
  facebook: {
    embedUrl: 'https://www.facebook.com/plugins/post.php?href=https://www.facebook.com/<%= remote_id %>&width=500',
    id: (ids) => ids.join('/'),
  },
  aparat: {
    embedUrl: 'https://www.aparat.com/video/video/embed/videohash/<%= remote_id %>/vt/frame',
  },
  miro: {
    embedUrl: 'https://miro.com/app/live-embed/<%= remote_id %>',
  },
  'gist.github': {
    embedUrl:
      'data:text/html;charset=utf-8,<head><base target="_blank" /></head><body><script src="https://gist.github.com/<%= remote_id %>" ></script></body>',
    id: (groups) => `${groups.join('/')}.js`,
  },
};
